import { render, staticRenderFns } from "./HelloWorld.vue?vue&type=template&id=469af010"
import script from "./HelloWorld.vue?vue&type=script&lang=js"
export * from "./HelloWorld.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3254644805/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('469af010')) {
      api.createRecord('469af010', component.options)
    } else {
      api.reload('469af010', component.options)
    }
    module.hot.accept("./HelloWorld.vue?vue&type=template&id=469af010", function () {
      api.rerender('469af010', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/HelloWorld.vue"
export default component.exports